import React from "react";
import loadable from "@loadable/component";
import { getShopType, isPODShop, SHOP_TYPES } from "../../helpers";

const LazyProductSearchModal = loadable(
  () => import("../../../ProductSearchModal"),
);
const LazyItem = loadable(() => import("../../../item/NewItem/Item"));

function ShopModal({
  modal,
  params,
  location,
  isAvalaraShop,
  shop,
  order,
  ...props
}: {
  modal?: string;
  params: Record<string, any>;
  location: any;
  isAvalaraShop: boolean;
  shop: any;
  order?: Record<string, any> | null;
  project?: any;
  popups?: any[];
  [key: string]: any;
}) {
  const shopType = getShopType(shop);
  const podShop = isPODShop(shop);

  switch (modal) {
    case "search":
      return (
        <LazyProductSearchModal
          params={params}
          location={location}
          order={order}
          isPoDShop={isPODShop(shop)}
          {...props}
        />
      );
    case "item":
      return (
        <LazyItem
          params={params}
          isAvalaraOrder={isAvalaraShop}
          showMetadataSection={
            shopType === SHOP_TYPES.POPUP_SHOP ||
            podShop
          }
          isPodShop={podShop}
          is_shop_free={shop?.is_shop_free}
          is_headless={shop?.is_headless}
          {...props}
        />
      );
    default:
      return null;
  }
}

export default ShopModal;
